import styles from "./Interaction.module.css"

function Interaction({ thisInteraction }) {
    const dataPartes = thisInteraction.date.split("-");
    const dia = dataPartes[2].slice(0, 2)
    const data = `${dia}/${dataPartes[1]}/${dataPartes[0]}`
    const horaPartes = dataPartes[2].split("T")
    const hora = horaPartes[1].slice(0, 5);



    return (
        <div className={styles.container}>
            <div className={styles.containerInfo}>
                <span className={styles.info}>
                    {`${thisInteraction.user} mudou o status para `}{
                        <span className={
                            thisInteraction.status === "Pendente" ? styles.status :
                                thisInteraction.status === "Agendada" ? styles.agendada :
                                    thisInteraction.status === "Finalizado" ? styles.finalizado :
                                        styles.andamento
                        }>
                            {thisInteraction.status}
                        </span>
                    }
                </span>
                <span className={styles.info}>
                    {data} - {hora}
                </span>
            </div>
            <p>{thisInteraction.message}</p>
        </div>
    )
}

export default Interaction;